import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-product-category-detail',
  templateUrl: './product-category-detail.component.html',
  styleUrls: ['./product-category-detail.component.css']
})
export class ProductCategoryDetailComponent implements OnInit {

  dialogData :any;

  constructor(public service: ProductCategoryService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private dialogRef: MatDialogRef<ProductCategoryDetailComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.dialogData = data;
   // this.description = data.description;
   }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      description: [description, []],

  });*/
  }
  counter(i: number) {
    return new Array(i);
}

onClose()
{
  this.service.form.reset();
  this.service.initializeFormGroup();
  this.dialogRef.close();
}

  onSubmit() {
    console.log("Create Customer");
  //  var error;
  //  var result = false;
    if (this.service.form.valid) {


      if (!this.service.form.get('id').value){
        this.service.insertData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submitted successfully", "Category Create");
            this.gnotify.showSnackBar('Category Create', 'Submitted successfully', "success");
            this.dialogData.result = true;
            this.onClose();
          },
          err=>{
             console.log(err);
             ////this.toastr.error("Failed to Submit", "Category Create");
             this.gnotify.showSnackBar('Category Create', 'Failed to Submit', "error");
             return false;
          }
          );
      }
      else{
        this.service.updateData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submitted successfully", "Category Modify");
            this.gnotify.showSnackBar('Category Modify', 'Submitted successfully', "success");
            this.dialogData.result = true;
            this.onClose();
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Category Modify");
            this.gnotify.showSnackBar('Category Modify', 'Failed to Submit', "error");
            return false;
          }
          );

      }

    }
    return true;
  }

}
